export const EShapeTextAlignVertical = wcardinal.ui.EShapeTextAlignVertical;